module.exports = __webpack_public_path__ + "media/images/logo-2f05cdc5cb891c3507d12df7788984ef.svg";